var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAddNoteIcon = function SvgAddNoteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13536_16264)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.3675 14.9042L16.9342 6.33751C17.585 5.68668 17.585 4.63168 16.9342 3.98084L15.9992 3.04501C15.3483 2.39418 14.2933 2.39418 13.6425 3.04501L5.075 11.6125C4.95334 11.7342 4.85167 11.8742 4.7725 12.0267L2.58084 16.2733C2.20917 16.9942 2.98167 17.7675 3.7025 17.3967L7.95167 15.2083C8.10584 15.1283 8.24584 15.0267 8.3675 14.9042Z",
    stroke: "#AEAEB2",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13536_16264"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
export { SvgAddNoteIcon as ReactComponent };
export default __webpack_public_path__ + "add-note-icon.svg";